// import React from "react";
// import { Box, Typography, Container } from "@mui/material";
// import Carousel from "react-material-ui-carousel";
// import UGNavbar from "../components/dessertationNavbar";
// import Scrollingbar from "../components/desserationscrolling";
// import CircularText from "../components/desserationrollingtext";

// const images = [
//   "md1.jpg",
//   "md3.jpg",
//   "matt-2.jpg",
//   "team8.jpg",
//   "173156179008out.jpg",
// ];

// const HomePage: React.FC = () => {
//   return (
//     <>
//       <Box>
//         <Box sx={{ position: "relative", minHeight: "100vh", backgroundColor: "#234152", color: "white" }}>
//           <Box
//             sx={{
//               position: "absolute",
//               width: "100%",
//               height: "100%",
//               zIndex: 0,
//             }}
//           >
//             <Carousel indicators={false} animation="slide" interval={3000}>
//               {images.map((image, index) => (
//                 <Box
//                   key={index}
//                   sx={{
//                     height: "100vh",
//                     backgroundImage: `url(${image})`,
//                     backgroundSize: "cover",
//                     backgroundPosition: "center",
//                     opacity: 0.1,
//                   }}
//                 />
//               ))}
//             </Carousel>
//           </Box>
//           <Box sx={{ position: "relative", zIndex: 1, textAlign: "center", py: 8 }}>
//             <Container
//               sx={{
//                 display: "flex",
//                 flexDirection: { xs: "column", md: "row" }, // Column on small screens, row on medium and up
//                 alignItems: "center",
//                 gap: 4
//               }}>
//               <Box>
//                 <Typography
//                   variant="h3"
//                   fontWeight={600}
//                   paddingTop={20}
//                   gutterBottom
//                   sx={{
//                     letterSpacing: '0.05em',
//                     lineHeight: 1.2,
//                     marginBottom: 4,
//                     fontFamily: '"Times New Roman", serif', // Change the font family
//                     fontStyle: 'italic', // Apply italic style if needed
//                     color: 'white',
//                   }}
//                 >
//                   Master's Dissertation Writing Services
//                 </Typography>



//                 <Typography
//                   variant="body1"
//                   sx={{
//                     maxWidth: "800px",
//                     fontSize: "1.1rem",
//                     lineHeight: 1.6,
//                     textAlign: "justify", // Changed to justify
//                     letterSpacing: '0.03em',
//                     fontWeight: 300,
//                     paddingX: 2, // Added horizontal padding for better readability
//                     color: 'white',
//                   }}
//                 >
//                   Writing a master's dissertation is a challenging task that requires extensive research,
//                   critical analysis, and academic writing expertise. At Matt Scholar Solutions, we provide
//                   top-notch Master's Dissertation Writing Services to help students achieve academic excellence.
//                   Our team of experienced writers, researchers, and editors ensures that your dissertation is
//                   well-structured, plagiarism-free, and meets the highest academic standards. Whether you need
//                   assistance with topic selection, literature review, methodology, or data analysis, we are here
//                   to guide you every step of the way.
//                 </Typography>
//               </ Box>

//               <Box sx={{ marginTop: { xs: "50px", md: "200px" } }}>
//                 <CircularText
//                   text="MATT*SCHOLAR*SOLUTIONS*"
//                   onHover="speedUp"
//                   spinDuration={20}
//                   className="custom-class"
//                 />
//               </Box>
//             </Container>
//           </Box>
//         </Box>
//       </Box>
//       <Scrollingbar />
//     </>
//   );
// };

// export default HomePage;







import React from "react";
import { Box, Typography, Container, Button, Grid, Divider } from "@mui/material";
import Carousel from "react-material-ui-carousel";
import UGNavbar from "../components/dessertationNavbar";
import Scrollingbar from "../components/desserationscrolling";
import CircularText from "../components/desserationrollingtext";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const images = [
  "md1.jpg",
  "md3.jpg",
  "matt-2.jpg",
  "team8.jpg",
  "173156179008out.jpg",
];

const DessertationHomePage: React.FC = () => {
  return (
    <>
      <Box>
        <Box sx={{ position: "relative", minHeight: "100vh", backgroundColor: "#234152", color: "white" }}>
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              zIndex: 0,
            }}
          >
            <Carousel indicators={false} animation="slide" interval={3000}>
              {images.map((image, index) => (
                <Box
                  key={index}
                  sx={{
                    height: "100vh",
                    backgroundImage: `url(${image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    opacity: 0.1,
                  }}
                />
              ))}
            </Carousel>
          </Box>
          <Box sx={{ position: "relative", zIndex: 1, textAlign: "center", py: 8 }}>
            <Container
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" }, // Column on small screens, row on medium and up
                alignItems: "center",
                gap: 4
              }}>
              <Box>
                <Typography
                  variant="h3"
                  fontWeight={600}
                  paddingTop={20}
                  gutterBottom
                  sx={{
                    letterSpacing: '0.05em',
                    lineHeight: 1.2,
                    marginBottom: 4,
                    fontFamily: '"Times New Roman", serif', // Change the font family
                    fontStyle: 'italic', // Apply italic style if needed
                    color: 'white',
                  }}
                >
                  Master's Dissertation Writing Services
                </Typography>



                <Typography
                  variant="body1"
                  sx={{
                    maxWidth: "800px",
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                    textAlign: "justify", // Changed to justify
                    letterSpacing: '0.03em',
                    fontWeight: 300,
                    paddingX: 2, // Added horizontal padding for better readability
                    color: 'white',
                  }}
                >
                  Writing a master's dissertation is a challenging task that requires extensive research,
                  critical analysis, and academic writing expertise. At Matt Scholar Solutions, we provide
                  top-notch Master's Dissertation Writing Services to help students achieve academic excellence.
                  Our team of experienced writers, researchers, and editors ensures that your dissertation is
                  well-structured, plagiarism-free, and meets the highest academic standards. Whether you need
                  assistance with topic selection, literature review, methodology, or data analysis, we are here
                  to guide you every step of the way.
                </Typography>

                {/* WhatsApp Button */}
                <Button 
  variant="contained" 
  startIcon={<WhatsAppIcon />}
  sx={{ 
    mt: 4, 
    bgcolor: '#009933', 
    '&:hover': { 
      bgcolor: '#25D366' 
    },
    borderRadius: '25px',
    px: 4, // Increases horizontal padding
    py: 1.5, // Increases vertical padding
    fontSize: '1rem', // Increases font size for better readability
    fontWeight: 'bold' // Makes text stand out more
  }}
  onClick={() => window.open('https://wa.me/8547486582', '_blank')}
>
  Chat with Us on WhatsApp
</Button>

              </ Box>

              <Box sx={{ marginTop: { xs: "50px", md: "200px" } }}>
                <CircularText
                  text="MATT*SCHOLAR*SOLUTIONS*"
                  onHover="speedUp"
                  spinDuration={20}
                  className="custom-class"
                />
              </Box>
            </Container>
          </Box>
        </Box>
      </Box>
      <Scrollingbar />
    </>
  );
};

export default DessertationHomePage;